import React, { ReactElement } from 'react'
import { LoginForm } from '../../Molecules/LoginForm/LoginForm'
import { WelcomeContainer } from '../WelcomeContainer/WelcomeContainer'
import { Branding } from '../../../../React/Common/API/BrandingAPI'
import { useBranding } from '../../../../React/Common/Hooks/useBranding'
import { isFusionFramed } from '../../../../NonReact/common/FusionThemeBridge'
import { FusionAuthRecovery } from './FusionAuthRecovery'

export const Authentication = (): ReactElement => {
    const branding: Nullable<Branding> = useBranding()

    // When CCS is embedded in the new UI and the session dropped to /auth, recover transparently from
    // the host's JWT instead of showing the login form inside the iframe (CXUI-583).
    if (isFusionFramed()) {
        return <FusionAuthRecovery />
    }

    return (
        <WelcomeContainer>
            <LoginForm branding={branding} />
        </WelcomeContainer>
    )
}
